/* eslint-disable no-restricted-globals */
// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import moment from 'moment';
// COMPONENTS
import MUIDataTable from "mui-datatables";
// ICONS
import { HiCheck } from 'react-icons/hi';
import { CgClose } from 'react-icons/cg';
// CUSTOM COMPONENTS
import LoadingScreen from '../../components/LoadingScreen';
import Section from '../../components/Section';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import Button from '../../components/Button';
import SelectBlock from '../../components/SelectBlock';
// SERVICES AND HELPERS
import { Alert } from '../../helpers/Alert';
import * as Helper from '../../helpers/helper';
import * as CompanyService from '../../services/company.service';
import * as QuoteService from '../../services/quote.service';

const QuoteListingPage = (props) => {
    const role = Helper.LoggedInUserRole();
    const [loading, setLoading] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(Helper.LoggedInCompanyId());
    const [data, setData] = useState([]);
    const loggedInUser = JSON.parse(localStorage.getItem('user'))
    const loggedInUserName = loggedInUser.firstName + ' ' + loggedInUser.lastName;

    useEffect(() => {
        if (role == 'SuperAdmin') {
            setLoading(true);
            CompanyService.GetAll().then(res => {
                setCompanies(res);
                setLoading(false);
            }).catch(ex => {
                setLoading(false);
            });
        }
        else
            LoadQuotes(selectedCompany);
    }, []);

    const LoadQuotes = (companyId) => {
        setLoading(true);
        QuoteService.GetAll(companyId).then(res => {
            setData(res);
            setLoading(false);
        }).catch(ex => {
            setLoading(false);
        });
    }

    const DuplicateQuote = (quoteId) => {
        setLoading(true);
        QuoteService.DuplicateQuote(quoteId).then(res => {
            Alert({ success: true, message: 'Campaign has been copied!' });
            LoadQuotes(selectedCompany);
            setLoading(false);
        }).catch(ex => {
            setLoading(false);
        });
    }

    const DeleteQuote = (quoteId) => {
        swal({
            title: 'Are you sure?',
            text: 'Are you sure you want to delete this campaign?',
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then(willDelete => {
            if (willDelete) {
                QuoteService.DeleteQuote(quoteId).then(res => {
                    LoadQuotes(selectedCompany);
                    Alert({ success: true, message: 'Campaign has been deleted!' });
                }).catch(ex => { });
            }
        });
    }

    const columns = [
        {
            name: 'id',
            label: 'Action',
            options: {
                filter: false,
                sort: false,
                print: false,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <CustomBlock className="content-container--actions pl-0 mt-0" style={{ justifyContent: "flex-start" }}>
                            <Button
                                text="Edit"
                                to={"/campaign/" + data[dataIndex].id}
                                size="xs"
                                className="primary--bg ml-0"
                            />

                            <Button
                                text="Duplicate"
                                onClick={() => {
                                    const hasConfirmed = confirm(`Are you sure you want to duplicate this campaign?`);

                                    if (hasConfirmed) {
                                        DuplicateQuote(data[dataIndex].id)
                                    }
                                }}
                                size="xs"
                                className="warning--bg"
                            />

                            {
                                role == 'User' ?
                                    <></> :
                                    <Button
                                        text="Delete"
                                        onClick={() => DeleteQuote(data[dataIndex].id)}
                                        size="xs"
                                        className="danger--bg"
                                    />
                            }
                        </CustomBlock>


                    );
                }
            }
        },
        {
            name: "client",
            label: "Client",
            options: {
                filter: true,
                sort: false
            }
        },
        {
            name: "createdOn",
            label: "Created On",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <p>{moment(data[dataIndex].createdOn).format('MM/DD/YYYY, hh:mm a')}</p>
                    );
                }
            }
        },
        {
            name: "createdByUser",
            label: "Created By",
            options: {
                filter: true,
                sort: false,
                filterList: [loggedInUserName],
            }
        },
        {
            name: "isSubmitted",
            label: "Submitted?",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {data[dataIndex].isSubmitted ? <HiCheck size={25} className="success--clr" /> : <CgClose size={25} className="danger--clr" />}
                        </>
                    );
                }
            }
        }
    ];


    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <CustomBlock className="main-container light--bg">
                        <Section>
                            <CustomBlock className="content-container--card-style">
                                <ContentHeader
                                    title="Campaigns"
                                    headerSize="mdlg"
                                    primaryButtonText={"Add"}
                                    primaryButtonTo="/new-campaign"
                                    primaryButtonBackgroundColor="success--bg"
                                />
                                <Section removeContainer>
                                    {
                                        role == "SuperAdmin" ?
                                            <ContentBlock>
                                                <SelectBlock
                                                    id="companyId"
                                                    name="companyId"
                                                    inputLabel="Company"
                                                    bordered
                                                    value={selectedCompany}
                                                    options={companies.map(x => Helper.SetOptionModel(x.businessName, x.id))}
                                                    onChange={option => {
                                                        option = option === null ? [] : option;
                                                        setSelectedCompany(option);
                                                        LoadQuotes(option.value);
                                                    }}
                                                />
                                            </ContentBlock> : <></>
                                    }
                                    <ContentBlock>
                                        <MUIDataTable
                                            data={data}
                                            columns={columns}
                                            options={{
                                                selectableRows: "none",
                                                searchOpen: true,
                                                searchAlwaysOpen: true,
                                            }}
                                        />
                                    </ContentBlock>
                                </Section>
                            </CustomBlock>
                        </Section>
                    </CustomBlock>
            }
        </>
    );
}

export default QuoteListingPage;